export default __webpack_public_path__ + "static/media/Nathan-Hadlock.84260332.jpg";